import { render, staticRenderFns } from "./answer repiter.vue?vue&type=template&id=15bec87c&scoped=true"
import script from "./answer repiter.vue?vue&type=script&lang=js"
export * from "./answer repiter.vue?vue&type=script&lang=js"
import style0 from "./answer repiter.vue?vue&type=style&index=0&id=15bec87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bec87c",
  null
  
)

export default component.exports